import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import FileUpload from '../../basic-component/uploadFile';
import TextLabel from '../../basic-component/TextLabel';
import { uploadFeedbackAttachment, apiHostUrl, addComment } from '../../../../constants/constants';
import { getconsentuserURL, updateConsent } from '../../../../constants/constants';
import { checkImageSignatureAndSize, clearFileInput, clickFileInput, handleFileChange } from '../../basic-component/CommonUtils';
import axios from "axios";
import { addCustomerResponseUrl } from "../../../../constants/constants";
import { Description } from '@mui/icons-material';
//import MultiSelectAttachment from ".../MultiSelectAttachment.jsx";
//import MultipleSelectAttachment from './MultiSelectAttachment';


const ConsentPopup = ({ onClose, t, keyComponent, customerResponseFormData, handleMailData, fetchfeedbackDetails }) => {
  debugger;
  const formData = new FormData();
  formData.append("feedback_id", customerResponseFormData.feedback_id);
  const [validationError, setValidationError] = useState({});
  const [snackSwitch, setSnackSwitch] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const [filename, setFilename] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { csrfToken } = useSelector((state) => state.csrf);
  const multiPartHeaders = {
    "Content-Type": "multipart/form-data",
    "X-CSRF-TOKEN": csrfToken,
  };
  const headers = {
    "Content-Type": "application/json",
    "X-CSRF-TOKEN": csrfToken,
  };
  const newHeaders = headers;
  newHeaders["X-Csrf-Token"] = csrfToken;
  newHeaders["Content-Type"] = "application/json";

  const handleFileNameChange = (event) => {
    const files = event?.target?.files;
    if (selectedFiles.length > 0) {
      const fileNames = selectedFiles.map(file => file.name).join(", ");
      setFilename(fileNames);
    } else {
      setFilename(t('general.label.no.file.chosen')); // fallback text if none selected
    }
  };
  const fileInputRef = useRef(null);
  const [commentans, setCommentAns] = useState('');
  const [spanComponent, setSpanComponent] = useState(<>No File Chosen</>);
  const handleCommentChange = (e) => {
    setCommentAns(e.target.value);
  };
  formData.append("_csrf", csrfToken);
  formData.append("_csrf", csrfToken);

  const handleSubmit = async () => {
    // Add validation or form submission logic here
    debugger;
    if (!commentans.trim()) {
      setValidationError({ commentError: t('general.error.comment.required') });
      return;
    }
    //For non-rest API
    // var feedbackFiles = document.querySelectorAll(".feedback-comment-file-list");
    // if (feedbackFiles && feedbackFiles.length > 0) {
    //   debugger;
    //     for (var i = 0; i < feedbackFiles.length; i++) {
    //       var fullPath = feedbackFiles[i].value;
    //       if (fullPath) {
    //         var startIndex =
    //           fullPath.indexOf("\\") >= 0
    //             ? fullPath.lastIndexOf("\\")
    //             : fullPath.lastIndexOf("/");
    //         var filename = fullPath.substring(startIndex);
    //         if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
    //           filename = filename.substring(1);
    //         }
    //         //alert(filename);
    //         if (filename) {
    //           formData.append(
    //             "addFileList[" + i + "].multipartFile",
    //             feedbackFiles[i].files[0]
    //           );
    //           formData.append("addFileList[" + i + "].fileName", filename);
    //         }
    //       }
    //     }
    //   }
    //  var feedbackFiles = document.querySelectorAll(".feedback-comment-file-list");
    const fileList = [];
    const readFileAsBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result.split(",")[1]; // Strip the data prefix
          resolve(base64Data);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };
    const payload = {
      feedback_id: customerResponseFormData.feedback_id,
      feedbackCode: customerResponseFormData.feedbackCode,
      commentGiven: commentans,
      addFileList: []
    };
    if (selectedFiles && selectedFiles.length > 0) {
      for (const file of selectedFiles) {
        // const input = feedbackFiles[i];
        // const files = input.files;

        // if (files && files.length > 0) {
        //   for (let j = 0; j < files.length; j++) {
        //     const file = files[j];

        // Get filename from file.name (more reliable than input.value)
        const filename = file.name;

        const base64Content = await readFileAsBase64(file);

        fileList.push({
          fileName: filename,
          fileContent: base64Content,
          contentType: file.type,
        });
        //}
        //}
      }
      payload.addFileList = fileList;
      /*for (var i = 0; i < feedbackFiles.length; i++) {
        var fullPath = feedbackFiles[i].value;
        if (fullPath) {
          var startIndex = fullPath.indexOf("\\") >= 0 ? fullPath.lastIndexOf("\\") : fullPath.lastIndexOf("/");
          var filename = fullPath.substring(startIndex);
          if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
            filename = filename.substring(1);
          }
          //alert(filename);
          if (filename) {
              formData.append(
                "addFileList[" + i + "].multipartFile",
                feedbackFiles[i].files[0]
              );
              formData.append("addFileList[" + i + "].fileName", filename);
            }
        }
      }*/
    }
    //     filename && formData.append("fileName", filename);
    filename && fileList.forEach(({ fileName }) => {
      formData.append("fileName", fileName);
    });
    formData.append("commentGiven", commentans);
    debugger;
    axios
      .post(`${apiHostUrl}${homeLink}${addCustomerResponseUrl}`, payload, {
        withCredentials: true,
        headers: {
          "X-CSRF-TOKEN": csrfToken
        },
      })
      .then((data) => {
        console.log(data);
        //debugger;
        if (data?.data?.success) {
          console.log("Response added successfully");

          setSnackSwitch(true);
          setSnackMsg(
            t("general.label.customer.response")
          );
        }
        //              MailList(data);
        //                handleMailData(data);
        debugger;
        fetchfeedbackDetails();
      })
      .catch((error) => {
        console.log(error);
        setSnackSwitch(true);
        setSnackMsg(t("general.label.unfortunately.no.response.submit"));
        //              onModalCloseHandler();
      });
    onClose(); // Close the popup on successful submit
  };

  const handleFileChange = (event, labelSelector) => {
    const files = event?.target?.files;
    const newFiles = Array.from(event?.target?.files || []);

    // 12 MB limit
    const maxFileSize = 12 * 1024 * 1024;

    const validFiles = [];
    for (const file of newFiles) {
      if (file.size > maxFileSize) {
        setValidationError({
          fileError: "File size cannot exceed 12 MB"
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }
      validFiles.push(file);
    }
    // clear file error when valid file selected
    setValidationError(prev => ({
      ...prev,
      fileError: ""
    }));

    const mergedFiles = [...selectedFiles, ...newFiles];
    setSelectedFiles(mergedFiles);
    if (event && event.target) {
      const parent1 = event.target.parentElement;
      const parent2 = parent1?.parentElement;

      if (labelSelector && parent2) {
        const labelEl = parent2.querySelector(labelSelector);
        if (labelEl) {
          if (mergedFiles.length > 0) {
            //         const fileNames = mergedFiles.map(file => file.name).join(", ");
            let span = mergedFiles.map(file => {
              return <div
                data-file-name="true"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
                className="multi-attachment-select">
                {file.name}
                <div
                  data-filename="${file.name}"
                  onClick={(e) => { e.stopPropagation(); handleRemoveFile(e, file.name); }}
                  className="remove-file-cross">&times;</div>
              </div>
            }

            );
            setSpanComponent(span);
          } else {
            labelEl.innerHTML = t('general.label.no.file.chosen');
          }
        }
      }
    }
  };

  const handleRemoveFile = (e, fileNameToRemove) => {
    debugger;
    setSelectedFiles(prev =>
      prev.filter(file => file.name !== fileNameToRemove)
    );
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    debugger;
    console.log("selectedFiles: " + selectedFiles);
    if (selectedFiles.length > 0) {
      //         const fileNames = mergedFiles.map(file => file.name).join(", ");
      let span = selectedFiles.map(file => {
        return <div className="multi-attachment-select">
          {file.name}
          <div
            data-filename="${file.name}"
            onClick={(e) => { e.stopPropagation(); handleRemoveFile(e, file.name); }}
            className="remove-file-cross">&times;</div>
        </div>
      });
      setSpanComponent(span);
    } else {
      setSpanComponent(<div className="multi-no-file-choosen">{t('general.label.no.file.chosen')}</div>);
    }
  }, [selectedFiles])


  const roles = useSelector((state) => state.role.userCurrRole.department.id)
  console.log(roles);
  const { homeLink } = useSelector((state) => state.role);
  console.log(homeLink);
  const fetchNamesrl = apiHostUrl + homeLink + getconsentuserURL;
  const fetchUrl = apiHostUrl + homeLink + uploadFeedbackAttachment;
  const updateUrl = apiHostUrl + homeLink + updateConsent;
  const addcommentUrl = apiHostUrl + homeLink + addComment;
  return (
    <Modal show onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t('general.label.comment.details')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='mb-3'>
          <Typography variant="subtitle1">
            {t('general.lable.otherReason.text')}:<span className="text-danger">*</span>
          </Typography>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder={t('general.error.comment.required')}
            value={commentans}
            onChange={handleCommentChange}
          />
          {validationError.commentError && (
            <Typography variant="caption" color="error">
              {validationError.commentError}.
            </Typography>
          )}
        </div>

        <div className='mb-3'>
          {keyComponent !== 'Close' && (
            <Form.Group controlId="formFile" className="mb-3">
              <TextLabel title={t("general.button.uploadFile")} isMandatory={false} />
              <span className="ms-2 fs-8">
                (.jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx,
                .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml)
              </span>
              <Form.Label className={"fw-medium feedback-add-files"}>
                {t("general.error.chooseFile.size")}
              </Form.Label>
              <InputGroup className="custom-file-uploader">
                <InputGroup.Text
                  onClick={(e) => clickFileInput(e, ".feedback-comment-file-list")}
                  className="text-section float-start start-0 w-100 bg-body-secondary p-0 z-0 position-relative rounded"
                >
                  <div className="p-2 me-2 border-end bg-body-secondary">
                    {t("general.label.choose.file")}
                  </div>
                  <div className="file-name-label-span">
                    {spanComponent}
                  </div>
                </InputGroup.Text>

                {/* <FileUpload
                  className={"feedback-comment-file-list d-none"}
                  fileTypes=" .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"
                  data={formData}
                  onChange={(e) => {
                    handleFileChange(e, ".file-name-label");
                    handleFileNameChange(e);
                  }}
                  fetchUrl={fetchUrl}
                  multiple
                /> */}
                <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  accept=" .jpg,.jpeg,.gif,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.xml,.xps,.msg,.eml"
                  data={formData}
                  className="feedback-comment-file-list d-none"
                  onChange={(e) => {
                    handleFileChange(e, ".file-name-label");
                    handleFileNameChange(e);
                  }}
                />
                {/* <MultipleSelectAttachment
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                labelSelector=".file-name-label" // Same as in your original code
                formData={formData}
                t={t} // Pass translation function if needed
              /> */}
                {/* <span
                  onClick={(e) => clearFileInput(e, ".feedback-comment-file-list")}
                  className="h-100 d-flex"
                > */}
                {/* <Button
                    variant="link"
                    className="border-0 text-decoration-none"
                  >
                    <i className="ti ti-x"></i>
                  </Button> */}

              </InputGroup>

              {validationError.fileError && (
                <Typography variant="caption" color="error">
                  {validationError.fileError}
                </Typography>
              )}
            </Form.Group>
          )}
        </div>

        <div className='text-end'>
          <Button variant="primary" onClick={handleSubmit} className='text-capitalize'>
            {t('general.button.submit.label')}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConsentPopup;